import { useCallback, useMemo } from "react";
import { useSearch, useNavigate } from "@tanstack/react-router";
import type { AdminSearchParams } from "@/features/admin/types";
import type { SortField, SortDirection } from "./categoryUtils";

export function useCategoriesSearchParams() {
  const search = useSearch({
    from: "/admin",
  }) as AdminSearchParams;
  const navigate = useNavigate({ from: "/admin" });

  const sorting = useMemo(() => {
    const sortColumn = search.categoriesSortBy as SortField | undefined;
    const sortDirection = (search.categoriesSortDirection ?? "asc") as SortDirection;
    return {
      sortField: sortColumn ?? ("order" as SortField),
      sortDirection,
    };
  }, [search.categoriesSortBy, search.categoriesSortDirection]);

  const updateSearchParams = useCallback(
    (updates: { sortField?: SortField; sortDirection?: SortDirection }) => {
      const newSearch: AdminSearchParams = { ...search };

      if (updates.sortField === undefined) {
        delete newSearch.categoriesSortBy;
        delete newSearch.categoriesSortDirection;
      } else {
        newSearch.categoriesSortBy = updates.sortField;
        newSearch.categoriesSortDirection = (updates.sortDirection ?? "asc") as "asc" | "desc";
      }

      navigate({
        search: newSearch,
        replace: true,
      });
    },
    [search, navigate]
  );

  return {
    sorting,
    updateSearchParams,
  };
}
